"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FileSlash: function() {
        return FileSlash;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const FileSlash = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M1.29289 1.2929C1.68342 0.902371 2.31658 0.902371 2.70711 1.2929L3.62142 2.20721C4.16698 1.47772 5.03391 1 6.01811 1H7.2H14C14.2652 1 14.5196 1.10536 14.7071 1.2929L20.7071 7.2929C20.8946 7.48043 21 7.73479 21 8V18.8V18.8264C21 19.0991 21 19.3514 20.9961 19.5818L22.7071 21.2929C23.0976 21.6834 23.0976 22.3166 22.7071 22.7071C22.3166 23.0976 21.6834 23.0976 21.2929 22.7071L19.2748 20.689L3.311 4.72522L1.29289 2.70711C0.902369 2.31658 0.902369 1.68342 1.29289 1.2929ZM5.08049 3.66628L19 17.5858V9H14C13.4477 9 13 8.55229 13 8V3H7.2H6.01811C5.59615 3 5.22366 3.27664 5.08049 3.66628ZM15 4.41422L17.5858 7H15V4.41422ZM4.01956 8.5C4.57184 8.5008 5.01891 8.94917 5.01811 9.50145L5.0029 19.9986C5.0021 20.5514 5.45005 21 6.0029 21H16.5C17.0523 21 17.5 21.4477 17.5 22C17.5 22.5523 17.0523 23 16.5 23H6.0029C4.34435 23 3.0005 21.6542 3.0029 19.9957L3.01811 9.49855C3.01891 8.94627 3.46727 8.4992 4.01956 8.5Z",
        fill: "currentColor"
    })
}), "FileSlash");
const _default = FileSlash;
